import { useEffect } from 'react';
import { useHistory, useRouteMatch } from 'react-router';

function CustomerDetailsPage() {
  const history = useHistory();
  const match = useRouteMatch<{ customerId: string }>();
  const { customerId } = match.params;

  useEffect(() => {
    if (match.isExact) {
      history.push(`/app/customers/${customerId}/general`);
    }
  }, [match]);

  return null;
}

export default CustomerDetailsPage;
